import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";

type Props = {
  totalAmount: number;
};

const PayPalPayment: React.FC<Props> = ({ totalAmount }) => {
  const navigate = useNavigate();

  return (
    <PayPalScriptProvider options={{ clientId: "AfbMiu_P2SXlxz_OeGbjyoKeEXF1AfYuehA6j0sVjnhqhszOJGmh5sPvOu5aZypoT88Dh_LOHNnC-NCe" }}>
      <div className="p-4">
        <h2 className="text-lg font-bold mb-4">Complete Your Payment</h2>
        <PayPalButtons
          createOrder={(data, actions) => {
            return actions.order.create({
              intent: "CAPTURE",
              purchase_units: [
                {
                  amount: {
                    currency_code: "USD",
                    value: totalAmount.toString(),
                  },
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            if (!actions.order) {
              console.error("Order actions are undefined.");
              return;
            }
            try {
              const details = await actions.order.capture();
              const payerName = details?.payment_source?.paypal?.name?.given_name ?? "Customer";
              alert(`Transaction completed by ${payerName}`);
              navigate("/success");
            } catch (error) {
              console.error("Error capturing order:", error);
            }
          }}
          onError={(err) => {
            console.error("Payment error:", err);
          }}
        />
      </div>
    </PayPalScriptProvider>
  );
};

export default PayPalPayment;
